// API Configuration for different environments
const getApiBaseUrl = () => {
  // In production, use environment variable (required for cloud deployment)
  if (process.env.NODE_ENV === 'production') {
    const apiUrl = process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_API_URL;
    if (!apiUrl) {
      console.error('❌ REACT_APP_BACKEND_URL is required in production');
      return '/api'; // fallback, but will likely fail
    }
    return apiUrl;
  }
  
  // In development, use local server for testing
  const port = process.env.REACT_APP_API_PORT || '5001';
  return `http://localhost:${port}`;
  
  // 🚀 REMOVED: Temporary CORS proxy - now using proper HTTPS setup
};

export const API_BASE_URL = getApiBaseUrl();

// API endpoints
export const API_ENDPOINTS = {
  // Plaid endpoints
  PLAID: {
    BASE: `${API_BASE_URL}/api/plaid`,
    STATUS: `${API_BASE_URL}/api/plaid/status`,
    ACCOUNTS: `${API_BASE_URL}/api/plaid/accounts`,
    TRANSACTIONS: `${API_BASE_URL}/api/plaid/transactions`,
    LIABILITIES: `${API_BASE_URL}/api/plaid/liabilities`,
    ITEM: `${API_BASE_URL}/api/plaid/item`,
    CREATE_LINK_TOKEN: `${API_BASE_URL}/api/plaid/create-link-token`,
    EXCHANGE_TOKEN: `${API_BASE_URL}/api/plaid/exchange-token`,
  },
  
  // AI endpoints
  AI: {
    BASE: `${API_BASE_URL}/api/ai`,
    INSIGHTS: `${API_BASE_URL}/api/ai/insights`,
    CHAT: `${API_BASE_URL}/api/ai/chat`,
    STATUS: `${API_BASE_URL}/api/ai/status`,
  },
  
  // Knowledge endpoints  
  KNOWLEDGE: {
    BASE: `${API_BASE_URL}/api/knowledge`,
    STORE: `${API_BASE_URL}/api/knowledge/store`,
    SEARCH: `${API_BASE_URL}/api/knowledge/search`,
    CATEGORIES: `${API_BASE_URL}/api/knowledge/categories`,
    ADVICE: `${API_BASE_URL}/api/knowledge/advice`,
    BULK_UPLOAD: `${API_BASE_URL}/api/knowledge/bulk-upload`,
  },
  
  // Health check
  HEALTH: `${API_BASE_URL}/api/health`,
};

// Fix for eslint warning
const apiConfig = {
  API_BASE_URL,
  API_ENDPOINTS,
};

export default apiConfig; 